<div class="dialog-container">
  <div class="dialog-header">
    <h5 class="mat-headline-6">{{ dialogTitle }}</h5>
    <button mat-icon-button class="close-button" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="form-container">
    <p [innerHTML]="message"></p>
  </div>
  <div class="dialog-actions">
    @if (!hideCancelButton) {
    <button mat-raised-button (click)="onCloseClick()" cdkFocusInitial>
      {{ cancelButtonText }}
    </button>
    } @if (hideCancelButton) {
    <button
      mat-raised-button
      class="cat-y-btn"
      (click)="onConfirm()"
      cdkFocusInitial
    >
      {{ confirmButtonText }}
    </button>
    } @else {
    <button mat-raised-button class="cat-y-btn" (click)="onConfirm()">
      {{ confirmButtonText }}
    </button>
    }
  </div>
</div>
